import { Avatar, Stack, TextField, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";
import React, { useState } from "react";
import { DamsInputProps, ModalInputProps } from ".";
import { DamsAppAsset } from "../../assets/registry";
import { Height } from "@mui/icons-material";
import { alignProperty } from "@mui/material/styles/cssUtils";


const ModalItemInput: React.FC<DamsInputProps> = ({
    label,
    placeholder = "Placeholder",
    name,
    handleChange,
    value,
    error,
    errorMessage,
    multiline,
    rows
}) => {
    return (
        <Stack
            width={'100%'}
            height={multiline ?'auto':75}
            gap={0.3}
        >
            <Typography
                fontFamily={'Inter'}
                color={'#344054'}
                fontSize={14}
                fontWeight={500}
            >
                {label}
            </Typography>


            <TextField
                variant="outlined"
                placeholder={placeholder ?? placeholder}
                fullWidth
                sx={styles.inputProps}
                name={name}
                value={value}
                onChange={handleChange}
                multiline={multiline}
                rows={rows}
            />
                <Typography variant="caption" color={"red"} sx={{marginLeft:1, minHeight:20}}>
                    {error && errorMessage}
                </Typography>
        </Stack>
    )
}

const styles = {
    inputProps: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#D0D5DD",
                borderRadius: "8px",
                // height: '50px',
            },
            "&:hover fieldset": {
                borderColor: "#D0D5DD",
                borderRadius: "8px",
                // height: '50px',
            },
            "&.Mui-focused fieldset": {
                borderColor: "#D0D5DD",
                borderRadius: "8px",
                // height: '50px',
            },
        },
        "& .MuiInputBase-input": {
            color: "#667085",
            // height: '50px',
        },
        "& .MuiInputBase-input::placeholder": {
            color: "#667085", // Placeholder color
            // height: '50px',
        },

        // height: '50px',
    },

}


export default ModalItemInput;
